<template>
	<div style="background-color: var(--vtm-surface)">
		<div style="padding: 20px">
			<el-row :gutter="20">
				<el-col :span="6">
					<div style="font-size: 18px; margin-bottom: 5px">
						{{ $t("myApps.paypalconfig") }}
					</div>
					<div style="margin-top: 10px">Client ID</div>
					<div
						v-if="PaypalConfig.clientId"
						style="margin-top: 5px; color: var(--vtm-ink-3); word-wrap: break-word">
						{{ PaypalConfig.clientId }}
					</div>
					<div
						v-else
						style="margin-top: 5px; color: var(--vtm-ink-3); word-wrap: break-word">
						{{ $t("myApps.weiconfig") }}
					</div>
					<div style="margin-top: 10px">Secret</div>
					<div
						v-if="PaypalConfig.secret"
						style="margin-top: 5px; color: var(--vtm-ink-3); word-wrap: break-word">
						{{ PaypalConfig.secret }}
					</div>
					<div
						v-else
						style="margin-top: 5px; color: var(--vtm-ink-3); word-wrap: break-word">
						{{ $t("myApps.weiconfig") }}
					</div>
					<el-button
						v-if="PaypalConfig.clientId"
						type="primary"
						@click="handleShowConfig('paypal')"
						size="small"
						style="margin: 15px 0 30px 0"
						>{{ $t("myApps.reconfig") }}</el-button
					>
					<el-button
						v-else
						type="primary"
						@click="handleShowConfig('paypal')"
						size="small"
						style="margin: 15px 0 30px 0"
						>{{ $t("myApps.btnconfig") }}</el-button
					>
				</el-col>
			</el-row>
		</div>
		<!-- Paypal配置 -->
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="this.$t('user.ppzfpz')"
			width="4.2rem"
			custom-class="PaypalConfig"
			:visible.sync="DialogPaypalConfig"
			:show-close="false"
			:close-on-click-modal="false"
			:close-on-press-escape="false">
			<div class="biaodan">
				<el-row>
					<el-col :span="24">
						<div style="font-size: 15px; margin-top: 10px">
							<div style="width: 100%; margin-bottom: 10px">
								<span style="color: red">*</span>
								<span> Client ID</span>
							</div>
							<el-input
								v-model="PaypalConfig.clientId"
								:placeholder="$t('user.bdcidh')"></el-input>
						</div>
						<div style="font-size: 15px; margin-top: 20px">
							<div style="width: 100%; margin-bottom: 10px">
								<span style="color: red">*</span>
								<span> Secret</span>
							</div>
							<el-input
								v-model="PaypalConfig.secret"
								:placeholder="$t('user.bdscth')"></el-input>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="tishi">
				<div class="content">
					{{ $t("myWallet.zhuyi") }}：<br />{{ $t("myWallet.paypaltips")
					}}<br />
					<a href="https://developer.paypal.com/" target="_blank"
						>https://developer.paypal.com/</a
					>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="DialogPaypalConfig = false" size="small">{{
					$t("common.cancel")
				}}</el-button>
				<el-button type="primary" @click="handlePaypalConfirm" size="small">{{
					$t("common.definite")
				}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: "paymentindex",
	data() {
		return {
			uId: "",
			DialogPaypalConfig: false,
			PaypalConfig: {
				id: 0,
				userId: "",
				clientId: "",
				secret: "",
			},
			DialogCashuConfig: false,
		};
	},
	mounted() {
		let _self = this;
		_self.LoadPpConfig();
	},
	methods: {
		handleShowConfig(type) {
			let _self = this;
			if (type == "paypal") {
				_self.DialogPaypalConfig = true;
			}
		},
		LoadPpConfig() {
			let _self = this;
			let uId = localStorage.getItem("uId");
			this.uId = uId;
			let obj = {
				uId,
			};
			_self.$api
				.request(_self.$url.User.getConfigByUserId, _self.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						console.log(res.data);
						if (res.data && res.data.id) {
							_self.PaypalConfig.id = res.data.id;
						} else {
							_self.PaypalConfig.id = 0;
						}
						if (res.data && res.data.userId) {
							_self.PaypalConfig.userId = res.data.userId;
						} else {
							_self.PaypalConfig.userId = uId;
						}
						if (res.data && res.data.clientId) {
							_self.PaypalConfig.clientId = res.data.clientId;
						} else {
							_self.PaypalConfig.clientId = "";
						}
						if (res.data && res.data.secret) {
							_self.PaypalConfig.secret = res.data.secret;
						} else {
							_self.PaypalConfig.secret = "";
						}
					}
				});
		},
		handlePaypalConfirm() {
			let _self = this;
			if (!_self.PaypalConfig.clientId) {
				_self.$message({
					message: _self.$t("user.bdcidh"),
					type: "warning",
				});
				return false;
			}
			if (!_self.PaypalConfig.secret) {
				_self.$message({
					message: _self.$t("user.bdscth"),
					type: "warning",
				});
				return false;
			}
			// 执行保存或更新
			if (_self.PaypalConfig.id) {
				// 修改
				let obj = {
					id: _self.PaypalConfig.id,
					clientId: _self.PaypalConfig.clientId,
					secret: _self.PaypalConfig.secret,
					uId: this.uId,
				};
				_self.$api
					.request(_self.$url.User.editPaypal, _self.$method.post, obj)
					.then(res => {
						_self.DialogPaypalConfig = false;
						if (res.code === 0) {
							_self.$message({
								message: _self.$t("user.configcg"),
								type: "success",
							});
						} else {
							_self.$message({
								message: _self.$t(res.msg),
								type: "error",
							});
						}
					});
			} else {
				// 执行添加
				delete _self.PaypalConfig.id;
				_self.$api
					.request(_self.$url.User.addPaypal, _self.$method.post, {
						..._self.PaypalConfig,
						uId: this.uId,
					})
					.then(res => {
						_self.DialogPaypalConfig = false;
						_self.PaypalConfig.id = 0;
						if (res.code === 0) {
							_self.$message({
								message: _self.$t("user.configcg"),
								type: "success",
							});
						} else {
							_self.$message({
								message: _self.$t(res.msg),
								type: "error",
							});
						}
					});
			}
		},
	},
};
</script>

<style lang="scss">
.PaypalConfig .el-dialog__header {
	padding: 20px 20px 10px 20px;
}
.PaypalConfig .el-dialog__footer {
	padding: 20px;
}
.PaypalConfig .el-dialog__body {
	padding: 0 20px;
	height: auto;
}
.PaypalConfig .biaodan {
	width: 100%;
}
.PaypalConfig .tishi {
	border-radius: 5px;
	border: 1px solid var(--vtm-warn);
	background-color: var(--vtm-warn-soft);
	margin-top: 20px;
}
.PaypalConfig .tishi .content {
	padding: 15px;
}
</style>
